module.exports = __webpack_public_path__ + "img/date.e7f80865.png";